import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function OwnerOverview() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => { api.get('/owner/stats').then(r=>setD(r.data)).catch(e => setErr(e?.response?.data?.error || 'Failed to load stats')); }, []);
  if (err) return <div className="alert alert-danger">{err}</div>;
  if (!d) return <div><span className="ap-loader"/></div>;
  const items = [
    ['My businesses', d.stats.businesses],
    ['Total views', d.stats.total_views],
    ['Enquiries', d.stats.total_enquiries],
    ['Products', d.stats.products],
    ['Services', d.stats.services],
  ];
  return (
    <div data-testid="owner-overview">
      <h2 className="mb-3">Business overview</h2>
      <div className="row g-3">
        {items.map(([l,v],i)=>(
          <div className="col-6 col-md-3" key={i}>
            <div className="stat-card" data-testid={`owner-stat-${i}`}>
              <div className="stat-label">{l}</div>
              <div className="stat-value">{v}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
